import { FC } from 'react';
import { dehydrate } from 'react-query';
import { useTranslation } from 'react-i18next';

import { PageProvider } from '@/context/PageContext';
import { ServicesByLocationPage } from './components/ServicesByLocation';
import { BranchOfficeHeader } from './components/BranchOfficeHeader';
import { BranchOfficeProps } from './BranchOffice.types';
import { withMinisiteOverview } from '@/entries/_shared/minisiteOverviewGssp';
import { useLocations } from '@/services/locations';
import { useIframeRouter } from '@/hooks/useIframeRouter';

const BranchOffice: FC<BranchOfficeProps> = (props) => {
  const { t } = useTranslation();
  const { countryCode, locationId, companyOverview, companySlug } = props;
  const { routerPush } = useIframeRouter();

  useLocations({
    companyId: companyOverview?.id,
    onSuccess: (data) => {
      const locationToLoad = data.find((location) => location.id === +locationId);

      if (!locationToLoad || !locationToLoad.validLocation) {
        routerPush(`/${countryCode}`);
      }
    },
  });
  return (
    <PageProvider
      companySlug={companySlug}
      locationId={locationId}
      companyOverview={companyOverview}
      nextSeo={{
        title: `${companyOverview?.name} | ${t('ONLINE_BOOKING')}`,
        description: `${t('SEO.LOCATIONS_DESCRIPTION_FIRST')} ${companyOverview?.name} ${t(
          'SEO.LOCATIONS_DESCRIPTION_SECOND',
        )}`,
      }}
    >
      <BranchOfficeHeader />
      <ServicesByLocationPage />
    </PageProvider>
  );
};

export const getServerSideProps = withMinisiteOverview(async (ctx, { companyOverview, companySlug, queryClient }) => {
  const { countryCode, locationId } = ctx.params as { countryCode: string; locationId: string };

  return {
    props: {
      companyOverview,
      countryCode,
      dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
      locationId,
      companySlug,
    },
  };
});

export default BranchOffice;
